<script>
  import { createEventDispatcher } from "svelte";
  import Button from "../UI/Button.svelte";
  import Location from "../Icons/Location.svelte";

  import Input from "../UI/Input.svelte";
  import { fade } from "svelte/transition";

  const dispatch = createEventDispatcher();

  export let locationText = "Austin, TX";
  export let locationSet = false;
  
  let plantsSubset = ["Pea", 'Cucumber', "Tomato"];
  let selectedButton = 0;
  function submitForm() {
    console.log('submitForm', locationText)
    locationText = locationText
    dispatch("plangarden", {
      locationText: locationText,
      plantsSubset: plantsSubset,
    });
  }
</script>

{#if !locationSet}
<article>
  <div class="info">
    <div  class="plant-image">
      <object  data="=../../static/plant-icons/location.svg" type="image/svg+xml"  title="clime location"></object>
    </div>
    <div class="location">
      <div>
      <h1>Build a successful home garden.</h1>
 
      <div class="plan">
        <div>
        <Input
        type="text"
        id="locationText"
        label="Enter your location to begin."
        validityMessage="Enter your location."
        value={locationText}
        on:input={(event) => (locationText = event.target.value)}
      />
    </div>
      <div class="button">        
        <Button mode="success" type="button" on:click={submitForm}
        >Plan my Garden</Button
      ></div>

      </div>

    </div>

    </div>
    
    <!-- <div class="filter">
      <Button
        type="button"
        class={selectedButton === 0 ? "active" : ""}
        on:click={() => {
          selectedButton = 0;
          dispatch("select", 0);
        }}
      >
        All
      </Button>
      <Button
        type="button"
        mode={selectedButton === 1 ? "active" : ""}
        on:click={() => {
          selectedButton = 1;
          dispatch("select", 1);
        }}
      >
        Favorites
      </Button>
    </div> -->
  </div>
</article>
{/if}

<style>
  article {
    display: flex;
    justify-content: center;
  }

  .info {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 50em;
    height: 500px;
  }

  .plan {
    display: flex;
    justify-content: left;
    align-items: center;
    width: 30em;
    gap: var(--space-4x);
  }

  .button {
    padding-top: var(--space-3x);

  }
</style>
